import React, { useState, useRef } from "react";
import '../styles/components/accordion.scss';

function Accordion(props) {
    //States
    const [setActive, setActiveState] = useState("");
    const [setHeight, setHeightState] = useState("0px");
    //Refs
    const content = useRef(null);
    
    //functionality
    function toggleAccordion() {
        setActiveState(setActive === "" ? "active" : "");
        console.log(content.current.scrollHeight);
        setHeightState(setActive === "active" ? "0px" : `${content.current.scrollHeight}px`);        
    }
    const count = (props.count < 10 ? "0"+props.count : props.count);
    
    return (
    <div className="accordionSection">
        <button className={`accordion ${setActive}`} onClick={toggleAccordion}>
        <p className="accordionTitle"><span>{count}</span> {props.title}</p>
            <span className="accordionIcon"></span>
        </button>
        <div 
            ref={content} 
            style={{ maxHeight: `${setHeight}` }} 
            className={`accordionContent ${setActive}`}>
            <div
                className="accordionText"
                dangerouslySetInnerHTML={{ __html: props.content }}
            />
        </div>
    </div>
    );
}

export default Accordion;